import React from "react";
import "../Uiux.css"
const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-module--footer_wrapper--0a44a row">
          <div className="footer-module--footer_col--7540c col-lg-3">
            <div className="footer-module--ft_col_inner--082cb">
              <h6>Follow us</h6>
              <ul className="footer-module--footer_social--32b12">
                <li>
                  <a
                    href="https://www.linkedin.com/company/alphai/mycompany/"
                    target="_blank"
                    aria-label="youtube"
                    rel="noreferrer"
                  >
                    <svg
                      width="10"
                      height="8"
                      viewBox="0 0 10 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.10509 0.398438H2.12815C1.12462 0.398438 0.320312 1.25779 0.320312 2.30295V5.69392C0.320312 6.75457 1.13937 7.59844 2.13553 7.59844H8.10509C9.11601 7.59844 9.92031 6.73908 9.92031 5.69392V2.30295C9.92031 1.25779 9.10125 0.398438 8.10509 0.398438ZM3.85482 5.54682V2.45005L6.37842 3.99844L3.85482 5.54682Z"
                        fill="white"
                      ></path>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/alphai/mycompany/"
                    target="_blank"
                    aria-label="linkedin"
                    rel="noreferrer"
                  >
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.72764 2.82247C2.33014 2.82247 2.81856 2.33405 2.81856 1.73155C2.81856 1.12905 2.33014 0.640625 1.72764 0.640625C1.12514 0.640625 0.636719 1.12905 0.636719 1.73155C0.636719 2.33405 1.12514 2.82247 1.72764 2.82247Z"
                        fill="white"
                      ></path>
                      <path
                        d="M2.81852 3.35938H0.636719V9.35938H2.81852V3.35938Z"
                        fill="white"
                      ></path>
                      <path
                        d="M7.92467 3.35938C6.28831 3.35938 6.09195 4.3303 6.09195 4.3303V3.35938H3.91016V9.35938H6.09195V6.08666C6.09195 6.08666 6.09195 4.99573 7.01923 4.99573C7.56467 4.99573 7.72831 5.48117 7.72831 6.08666V9.35938H9.91011V6.08666C9.91011 4.37938 9.16831 3.35938 7.92467 3.35938Z"
                        fill="white"
                      ></path>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/alphai/mycompany/"
                    target="_blank"
                    aria-label="twitter"
                    rel="noreferrer"
                  >
                    <svg
                      width="12"
                      height="10"
                      viewBox="0 0 12 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.82 0.801266C10.3796 1.06217 9.89827 1.24658 9.39633 1.3467C8.96977 0.899329 8.37811 0.646861 7.75997 0.648501C6.5423 0.639361 5.54452 1.61277 5.52361 2.8303C5.52412 2.99933 5.54423 3.16775 5.58361 3.33214C3.79027 3.24749 2.11538 2.41203 0.969047 1.03034C0.772969 1.36077 0.667594 1.73708 0.663609 2.12127C0.663656 2.86203 1.03955 3.55213 1.66181 3.95399C1.30645 3.94241 0.958828 3.84711 0.64725 3.67578C0.64725 3.67578 0.64725 3.67578 0.64725 3.70306C0.643687 4.76698 1.39716 5.68311 2.44181 5.88486C2.11252 5.97266 1.7677 5.98569 1.43273 5.92306C1.73391 6.82428 2.5717 7.43675 3.52181 7.45034C2.73084 8.06544 1.75833 8.40111 0.756375 8.40491C0.574078 8.40472 0.391922 8.3938 0.210938 8.37219C1.23741 9.0215 2.42723 9.3658 3.64186 9.36491C7.10559 9.42819 9.96483 6.67152 10.0281 3.20778C10.0288 3.17108 10.0291 3.13438 10.0291 3.09763C10.0291 3.00308 10.0291 2.90853 10.0291 2.81399C10.4566 2.50067 10.8259 2.11484 11.1201 1.67399C10.7106 1.85328 10.2768 1.97089 9.83278 2.02306C10.2997 1.74974 10.6508 1.31525 10.82 0.801266Z"
                        fill="white"
                      ></path>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/alphaisolutions/?ref=pages_you_manage"
                    target="_blank"
                    aria-label="facebook"
                    rel="noreferrer"
                  >
                    <svg
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.03233 2.26778V3.3587H0.941406V4.99506H2.03233V9.90414H4.21413V4.99506H5.66505L5.85048 3.3587H4.21413V2.40414C4.21413 1.96234 4.25777 1.72778 4.93956 1.72778H5.85048V0.0859375H4.38869C2.64325 0.0859844 2.03233 0.90414 2.03233 2.26778Z"
                        fill="white"
                      ></path>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/alphai_solutions/"
                    target="_blank"
                    aria-label="instagram"
                    rel="noreferrer"
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.3913 0.554688H2.84586C1.64089 0.554688 0.664062 1.53152 0.664062 2.73648V9.28192C0.664062 10.4869 1.64089 11.4637 2.84586 11.4637H9.3913C10.5963 11.4637 11.5731 10.4869 11.5731 9.28192V2.73653C11.5731 1.53152 10.5963 0.554688 9.3913 0.554688ZM8.30038 2.19105H9.93674V3.82741H8.30038V2.19105ZM6.11858 3.82745C7.32355 3.82745 8.30038 4.80428 8.30038 6.00925C8.30038 7.21422 7.32355 8.19105 6.11858 8.19105C4.91361 8.19105 3.93678 7.21422 3.93678 6.00925C3.93678 4.80428 4.91361 3.82745 6.11858 3.82745ZM10.4822 9.28197C10.4822 9.88445 9.99378 10.3729 9.3913 10.3729H2.84586C2.24338 10.3729 1.75494 9.88445 1.75494 9.28197V5.46377H2.90038C2.57281 7.24131 3.7482 8.94784 5.52575 9.27545C7.3033 9.60306 9.00983 8.42762 9.33744 6.65008C9.37639 6.43877 9.39444 6.22412 9.3913 6.00925C9.38858 5.8262 9.37034 5.64377 9.33673 5.46381H10.4822V9.28197H10.4822Z"
                        fill="white"
                      ></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            <form >
              <div className="footer-module--subscribe_wrap--00463">
                <input
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={''}
                />
              
             
              </div>
              <div className="pt-4">
              <button
                  className="formButtonRed-module--btn_red--27355 undefined "
                  type="button"
                >
                  Subscribe
                </button>
              </div>
            </form>
          </div>
          <div className="footer-module--footer_col--7540c col-lg-3">
            <div className="footer-module--ft_col_inner--082cb">
              <h6>GCC</h6>
              <p>
                U12, B360, South
                <br /> Mawaleh, <br />
                Muscat, Oman
                <br />
                <a href="tel:+968 991 60 109">+968 991 60 109</a>
              </p>
              <a href="mailto:gcc@alphai.dev">
              gcc@alphai.dev
              </a>
            </div>
          </div>
          <div className="footer-module--footer_col--7540c col-lg-3">
            <div className="footer-module--ft_col_inner--082cb">
              <h6>South Asia</h6>
              <p>
              Block A Plaza# 1,<br /> Next to Askari Bank<br /> Valencia Town <br/>commercial market 
                <br /> Lahore 54000,PK
                <a href="tel:+92 333 5489960">+92 333 5489960</a>
               
              </p>
              <div>
                  <a
                    href="mailto:sa@alphai.dev"
                    className=""
                  >
                   sa@alphai.dev
                  </a>
                </div>
              <div className="footer-module--ft_col_inner--082cb">
                {/* <h6>Email</h6>
            <p>
              Business:
              <a href="mailto: info@alphaisolutions.com"
                >info@alphaisolutions.com</a
              >
            </p>
            <p>
              HR:
              <a href="mailto: info@xmediaglobal.com"
                >info@alphaisolutions.com</a
              >
            </p> */}
              </div>
              {/* <form>
              <div className="footer-module--subscribe_wrap--00463">
                <input
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                /><button
                  className="formButtonRed-module--btn_red--27355 undefined"
                  type="submit"
                >
                  Subscribe
                </button>
              </div>
            </form> */}
            </div>
          </div>
          <div className="footer-module--footer_col--7540c col-lg-3">
            <div className="footer-module--ft_col_inner--082cb">
              <h6>DACH</h6>
              <p>
              Wilhelm-Hammann-Strabe <br />
              42 64572 <br />
              Buttelborn
                <br />
                <a href="tel:+4917645702641">+491 764 57 02641</a>
              </p>
              
              <a href="mailto: info@xmediaglobal.com">
              dach@alphai.dev
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-module--footer_bottom--38fa6">
        <ul className="footer-module--footer_nav--a1a38"></ul>
        <span className="footer-module--copy--056de">
          © 2022 – 2024 Alphaisolution. All Rights Reserved
        </span>
      </div>
    </footer>
  );
};

export default Footer;
